import React from 'react';
import PhaserGame from './components/PhaserGame';

function App() {
  return (
    <div className="min-h-screen w-full bg-gray-800 flex flex-col justify-center items-center py-6 sm:py-8">
      <main className="shadow-2xl rounded-lg overflow-hidden border-4 border-gray-700">
        <PhaserGame />
      </main>
      <footer className="mt-6 sm:mt-8 text-center text-gray-400 px-4">
      </footer>
    </div>
  );
}

export default App;